export default __webpack_public_path__ + "static/media/GY.8712285b.svg";